import { TableDataQuery, getData } from '../get-table'
import { HttpService } from '../http.service'
import { usePayrollStore } from '@/store/payroll-data'

interface FormOptions {
  entity: string
  country?: string
  company?: string
  integrations?: string[]
}
export interface Field {
  id: string
  name: string
  label: string
  type: string
  props?: any
  editingProps?: any
  rules?: string[]
  query?: TableDataQuery
  default?: string | number | boolean | []
  dependsOn?: {
    field: string
    filterTag?: string
  }
  if?:
    | {
        field: string
        value: string | number | boolean | string[]
      }
    | string
}
interface Group {
  name: string
  description?: string
  fields: Field[]
}
interface Tab {
  name: string
  description?: string
  groups: Group[]
  featureFlag?: string
  hideWhenFlag?: string
}

export interface Form {
  entity: string
  tabs: Tab[]
}
const http = new HttpService()

export async function getForm(opts: FormOptions): Promise<Form> {
  let form = {}
  let { entity, country, company, integrations } = opts

  if (country === undefined)
    country = usePayrollStore().payroll?.country?.iso_code ?? ''
  if (company === undefined)
    company = usePayrollStore().payroll?.company?.id ?? ''
  if (integrations === undefined) integrations = []

  const response: any = await http.post('general/forms/get-form/front', {
    entity,
    country,
    company,
    integrations
  })

  form = response?.data?.data ?? {}

  return form as Form
}

export function getCustomProps(data: any): any {
  const customFields = new Map<string, any>([])
  Object.keys(data).forEach(key => {
    if (key.startsWith('custom:')) {
      const nData: any = data
      customFields.set(key, nData[key])
    }
  })
  return Object.fromEntries(customFields)
}

export function getSubCustomProps(data: any): any {
  return data.map((item: any) => {
    const customFields: any = {}
    for (const key in item) {
      if (key.startsWith('custom:')) {
        customFields[key] = item[key]
        delete item[key]
      }
    }
    return { ...item, customFields }
  })
}

export function getNotCustomProps(data: any): any {
  const noCustomFields = new Map<string, any>([])
  Object.keys(data).forEach(key => {
    if (!key.startsWith('custom:')) {
      const nData: any = data
      noCustomFields.set(key, nData[key])
    }
  })
  return Object.fromEntries(noCustomFields)
}

export async function getDataTable(table: string, id: string): Promise<any> {
  const data: Tables = {
    tables: [`pg_${table}`],
    fields: ['*']
  }
  if (id !== '') data.where = [`id = '${id}'`]
  const result = await getData<any>(data)
  return result[0].results
}

export interface Tables {
  tables: string[]
  fields: string[]
  where?: string[]
}
